import { Back } from '../icons/Back/Back';
import { More } from '../icons/More/More';

export const mapCoachResponseListItems = (generateMore, navigate, theme) => [
  {
    name: 'more',
    icon: <More />,
    onClick: generateMore,
  },
  {
    name: 'back',
    icon: <Back fontSize="large" sx={{ color: theme.palette.tertiary.main }} />,
    onClick: () => navigate(-1),
  },
];
